/* Custom feature card design for home page - MCM difference - Created by Monica - Nov 12 2024*/

// Select all cards, but apply styles only to those in the first section
document.querySelectorAll('.media-icon-item-layout-card').forEach((item, index) => {
  // Assuming the first section cards come before the second section cards in the DOM:
  if (index < document.querySelectorAll('.media-icon-items-grid-3')[0].children.length) {
    // Set up card styling for the first section
    item.style.backgroundColor = '#D3D9FD'
    item.querySelector('p').style.color = '#110D82'
    item.querySelector('h5').style.color = '#110D82'
    item.querySelector('h5').style.fontWeight = 'normal'
    item.style.border = 'none'
    item.style.borderRadius = '15px'
    item.style.display = 'flex' // Use flexbox to control the layout
    item.style.flexDirection = 'row' // Arrange elements in a horizontal row
    item.style.alignItems = 'flex-start' // Align all elements at the top
    item.style.paddingTop = '30px' // Add extra padding at the top
    item.style.paddingRight = '20px' // Standard padding for right side
    item.style.paddingBottom = '20px' // Standard padding for bottom side
    item.style.paddingLeft = '20px' // Standard padding for left side
    item.style.gap = '15px' // Add gap between the SVG and the text content
  }
})

// Style the SVG to ensure it stays aligned at the top (only for the first section)
document.querySelectorAll('.media-icon-item-content svg').forEach((item, index) => {
  if (index < document.querySelectorAll('.media-icon-items-grid-3')[0].children.length) {
    item.style.fill = '#ffcc00'
    item.style.width = '50px'
    item.style.height = '50px'
    item.style.flexShrink = '0' // Prevent the SVG from shrinking
  }
})

// Set the text container styles for proper alignment and spacing (only for the first section)
document.querySelectorAll('.media-icon-item-content').forEach((content, index) => {
  if (index < document.querySelectorAll('.media-icon-items-grid-3')[0].children.length) {
    content.style.display = 'flex' // Set flexbox to control the text layout
    content.style.flexDirection = 'column' // Arrange heading and paragraph vertically
    content.style.justifyContent = 'flex-start' // Align text at the top
    content.style.alignItems = 'flex-start' // Align text to the left
  }
})
